import React from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose } from 'ramda';
import { List } from 'immutable';
import connect from 'react-redux/es/connect/connect';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import { contextualizeAppConfig } from "@synergycms_core/store/app/utils";
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import Image from '@synergycms_core/components/generic/Image';

import LoyaltyModal from '../Modal/index';

export const LoyaltyPublic = ({ theme, theme : { styles : { classes }}, hotelName, loyaltyUser, customerForm, content, advantages, hotelConfig}) => {

  const getLoyaltyLogoText = (key) => {
    const translated = content ? content.t(`_%${key}%_`) : '';
    return translated.trim() !== '' && translated !== key ? translated : null;
  };

  const isMobile = theme && theme.width < 901;
  const loyaltyLogoText = getLoyaltyLogoText(isMobile ? 'loyalty_logo_text_mobile' : 'loyalty_logo_text');
  const advantagesList = advantages ? advantages : List();
  const loyaltyReverseButton = hotelConfig.getIn(['loyalty_banner', 'loyalty_reverse_button'], false);

  return (
    <div className={classes.public} >
      <div className={[classes.starLogo, customerForm ? classes.customerFormLogo : ''].join(' ')}>
        { !!loyaltyLogoText ? (
          <RichText
            text={loyaltyLogoText}
            translate={true}
            dangerouslySetInnerHTML={true}
            innerStyle={classes.logoText}
          />
        ) : (
          <Image svg={'memberOnlyWhite'} innerStyle={[classes.logoSvg]}/>
        )}
      </div>
      <div className="title">
        <RichText translate={true}
          dangerouslySetInnerHTML={true}
          withVars={{NOMBREHOTEL: hotelName}}
          text={'_%consigue ventajas fidelizacion%_'}
          ucFirst={true}
          innerStyle={classes.starTabTitle}/>
      </div>
      <ul className={["text", customerForm ? "customerFormText" : ''].join(' ')}>
        {advantagesList && advantagesList.size > 0 && (
          advantagesList.slice(0, 3).map((advtage) => {
            const benefitIconSyn = advtage.get('icon')
              ? `${process.env.URL_ENVIRONMENT}/api/medias/${advtage.get('icon')}`
              : false;

            return (
              <li key={advtage.get('id')}>
                {benefitIconSyn && (
                  <div className={classes.advantagesIcons}>
                    <Image
                      svg={benefitIconSyn}
                      remoteSvg={true}
                      innerStyle={classes.advantageIcon}
                    />
                  </div>
                )}
                <div>
                  {advtage.get('title') && (
                    <b>
                      <RichText
                        text={advtage.get('title')}
                        innerStyle={classes.advantagesTextBold}
                        ucFirst={true}
                      />
                    </b>
                  )}
                </div>
              </li>
            );
          })
        )}
      </ul>
      <div className={classes.flex}>
        <LoyaltyModal view={'register'}>
          <Button
            richText={{
              text: '_%register fidelizacion%_',
              ucFirst: true,
              innerStyle: ['uppercase'],
              translate: true
            }}
            innerStyle={['toggleSecondButton', classes.buttonRegister].join(' ')}
          />
        </LoyaltyModal>
        <LoyaltyModal view={'login'}>
          <Button
            richText={{ text: '_%login fidelizacion%_', ucFirst: true, innerStyle: ['uppercase'], translate: true }}
            innerStyle={['toggleSecondButton', loyaltyReverseButton ? classes.buttonLoginReverse : classes.buttonLogin].join(' ')}
          />
        </LoyaltyModal>
      </div>
    </div>
  );
}

const mapStateToProps = (store) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotel = store.getIn(['hotels', hotelId], undefined);

  return {
    hotelName : hotel.get('name'),
    loyaltyUser: store.getIn(['customer', 'loyalty', 'user'], null),
    advantages: store.getIn(["customer", "loyalty", "data", "advantages"], null),
    hotelConfig: contextualizeAppConfig(store, hotelId),
  };
};

export default compose(
  PropertyManager(["advantages"]),
  withThemeJSS({ styleFile, link: true, displayName: 'FidelTourPublic' }),
  withContent('i18n'),
  connect(
    mapStateToProps
  ),
)(LoyaltyPublic);


